import { reactive } from "vue";

import type { Config } from "@/models/config";
import useGetAttributes from "./get-attributes";

const config: Config = reactive({
  activeLanguages: ["de", "en"],
  backendPath: "",
  viteBasePath: "",
  apiPath: "",
  defaultLang: "de",
  affiliationSearchString: "___",
  importPersonLimit: 25,
  personsMergeToolEnabled: true,
  headerSubtitleUrl: "https://www.ub.uni-freiburg.de",
  headerSubtitleText: "Universitätsbibliothek Freiburg",
  logoUrl: "https://www.uni-freiburg.de",
  headerTitleText: "openRS",
  systemId: "openRS",
  instanceName: "openRS",
  cssPrefix: "openRS",
  freidokBaseUrl: "https://freidok.uni-freiburg.de",
  reportToolUrl: "https://freidok.uni-freiburg.de/report",
  fachsigelEnabled: true,
  doiPrefix: "",
  doiSubPrefix: "",
  doiRegistrationEnabled: true,
  gndEnabled: true,
  urnEnabled: true,
  orcidEnabled: true,
  availableDoctypes: [],
  availableAcquisitionTypes: [],
  availableLicenseTypes: [],
  availableOAStates: [],
  availableFachsigel: [],
  availableSubmissionTypes: [],
  availableActivityTypes: [],
  contactMail: "",
  publicationFieldsByPubtype: {},
});

export default function useConfig() {
  async function initConfig() {
    // Basiskonfiguration laden
    const baseConfig: Config = {
      backendPath: import.meta.env.VITE_BACKEND_PATH,
      viteBasePath: import.meta.env.VITE_BASE_PATH,
    } as Config;
    baseConfig.apiPath = baseConfig.backendPath + "/jsonApi/v1";
    Object.assign(config, baseConfig);

    // Serverseitige Konfiguration laden
    const serverSideConfigRes = await fetch(`${config.apiPath}/getConfig`);
    const serverSideConfig: Config = await serverSideConfigRes.json();
    Object.assign(config, serverSideConfig);

    // Attributes holen
    const { attributes, getAttributes } = useGetAttributes();
    await getAttributes(
      [
        "doctype",
        "erwerbungsart",
        "license_type",
        "oastatus",
        "submission_type",
        "fachsigel",
        "bwatype",
      ],
      "de"
    );
    config.availableDoctypes = attributes.value["doctype"];
    config.availableAcquisitionTypes = attributes.value["erwerbungsart"];
    config.availableLicenseTypes = attributes.value["license_type"];
    config.availableOAStates = attributes.value["oastatus"];
    config.availableSubmissionTypes = attributes.value["submission_type"];
    config.availableFachsigel = attributes.value["fachsigel"];
    config.availableActivityTypes = attributes.value["bwatype"];
  }

  return { config, initConfig };
}
